// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__38v0R","ranges":"BmiRanges_ranges__3cxK4"};